import {Pagination} from '@/utils/pagination';

export const initialState = {
    login: {
        loginFormView: 'sign-in-form'
    },

    authentication: {
        loggedIn: false,
        userInfo: null,
        schoolInfo: null
    },

    notifications: {
        notifications: []
    },

    spinner: {
        isLoading: false,
        isProgress: false
    },

    profile: {
        profileInfo: {
            firstName: null,
            lastName: null,
            phone: null,
            email: null,
            address: null
        },
        profileAvatar: null,
        hasHeadingAvatarLoaded: false,
        editProfileInfo: null,
        notificationsStatus: null
    },

    modals: {
        modal: null,
        closeModalCallback: null,
        options: null
    },

    confirmationModal: {
        isFadeShown: false,
        isConfirmShown: false,
        confirmationModal: {
            title: null,
            description: null,
            callback: null
        }
    },

    children: {
        children: null,
        childId: null,
        childInfo: {
            picture: null,
            contactPersons: null,
            approvedPickups: [],
            grade: null
        },
        childScheduleInfo: null,
        childPhoto: null,
        childInfoForEdit: {
            firstName: null,
            lastName: null,
            birthDate: null,
            gender: null,
            grade: null,
            allergies: null,
            id: null,
            specialNeeds: null,
            approvedPickups: [
                {
                    firstName: null,
                    lastName: null,
                    relationship: null
                }
            ],
            contactPersons: [
                {
                    firstName: null,
                    lastName: null,
                    email: null,
                    phone: null
                }
            ]
        }
    },

    activities: {
        activitiesInfo: null,
        classes: null,
        camps: null,
        campPricing: null,
        aftercareSessions: null,
        aftercareDay: null,
        activity: null,
        activitiesClassRequired: null,
        activitiesCampRequired: null,
        activitiesAftercareRequired: null,
        activitiesAftercareDropInFull: null,
        teachers: null,
        pickUps: null,
        tShirtSizes: null,
        activityExtras: null,
        activityExtrasCamp: null,
        activityExtrasAftercare: null,
        activityExtrasAftercareWhichUsesBefore: null,
        childRosterInfo: null,
        policies: null,
        activityForms: [],
        activitiesAftercareRostersFreeDays: [],
        activitiesAftercareWaitlistFreeDays: [],
    },

    pageOptions: {
        pagination: new Pagination(),
        locations: null,
        searchQuery: null,
        sortBy: null,
        sortDirection: null,
        filters: {
            locationIds: {},
            grades: {},
            ages: {},
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            sunday: true,
            invoiceStatus: null,
        },
        modalFilters: {
            invoiceStatus: null,
        }
    },

    shoppingCart: {
        shoppingCart: {
            discount: 0,
            fees: 0,
            rosters: null,
            totalPrice: 0
        },
        shoppingIndicator: false,
        existCard: null,
        isPaid: false,
        couponCode: null,
        freeActivity: false
    },

    receipts: {
        receiptsInfo: null,
        isNewPaymentFlowFeature: null,
        paynowReceiptsPaginationParams: {
            from: 0,
            to: 10,
            page: 0,
            isPrevDisabled: true,
            isNextDisabled: false,
        },
        paynowTransactionPageSize: 10,
    },

    calendar: {
        selectedChild: null,
        mode: 'Month',
        date: new Date(),
        activityDates: {},
        isChildDropdown: false
    },

    customForms: {
        forms: []
    },
    payment : {
        methods: [],
        clientSecret: null,
        paymentPayload: {},
        isCleaningInProgress: false,
        invoiceData: null,
        coupons: [],
        payNowEnrollmentData: {},
        isPaymentMethodsLoading: false,
    }
};


// WEBPACK FOOTER //
// ./src/store/initialState.js